import { ApiError } from '@/services/api/ApiError'

/**
 * A request outlived the session it was sent under: the user signed out (or a
 * different user signed in) before it could be retried. The request is
 * abandoned without being sent again. Optimistic rollbacks and the global
 * error toast skip it — the logout already reset everything, and restoring a
 * snapshot now would write the previous user's data back into the cache.
 */
export class SessionChangedError extends ApiError {
  constructor() {
    super('Session expired. Please log in again.', 401)
    this.name = 'SessionChangedError'
  }
}
